// extracted by mini-css-extract-plugin
export default {"root":"C4WfcdEBY7GBDTm9Vgg1","box":"OocboZwcmCGeBrke47dQ","close":"cBIH9yKu1Rtpy9UzvXJ5","days":"Uxl3wbFUG2LoJhmRnkBe","content":"AJgUwbaDNScEwoOMSzIa"};